<form #form="ngForm" class="material">
    <div>{{ 'document.reviewedAndAcknowledged' | translate }}</div>
</form>
